import { PR_STATUS } from "@/constants/productStock";

export const PR_ALREADY_DELETED_MESSAGE =
  "รายการนี้ถูกลบไปแล้ว กรุณารีเฟรชหน้าเพื่ออัปเดตข้อมูล";
export const PR_HAS_PO_MESSAGE =
  "ลบไม่ได้ เพราะใบขอซื้อนี้มีการสั่งซื้อแล้ว กรุณารีเฟรชหน้า";
export const PR_DELETE_FAILED_MESSAGE = "ลบใบขอซื้อไม่สำเร็จ กรุณาลองใหม่";

// What the API returns (400) when the PR is no longer DRAFT/SENT_TO_ERP. It
// doesn't say why (already deleted vs. already has a PO), so we look the PR
// up again. Must match StockManagementErrors in tantatat-api.
export const PR_CANNOT_CANCEL_INVALID_STATUS =
  "ยกเลิกได้เฉพาะใบขอซื้อสถานะ DRAFT หรือ SENT_TO_ERP เท่านั้น";

const messageForStatus = status => {
  if (status === PR_STATUS.CANCELED) return PR_ALREADY_DELETED_MESSAGE;
  if (status === PR_STATUS.PARTIALLY_ORDERED || status === PR_STATUS.CLOSED) {
    return PR_HAS_PO_MESSAGE;
  }
  return PR_DELETE_FAILED_MESSAGE;
};

// `fetchLatestPr` re-reads the PR (resolves to it, rejects with an HTTP error).
// Anything we can't explain, including an ERP rejection, stays a plain failure
// the user can retry.
export async function getPrDeleteErrorMessage(err, fetchLatestPr) {
  const status = err?.response?.status;
  if (status === 404) return PR_ALREADY_DELETED_MESSAGE;

  const apiMessage = err?.response?.data?.errorMessage;
  if (status !== 400 || apiMessage !== PR_CANNOT_CANCEL_INVALID_STATUS) {
    return PR_DELETE_FAILED_MESSAGE;
  }

  try {
    const latest = await fetchLatestPr();
    return messageForStatus(latest?.status);
  } catch (lookupErr) {
    return lookupErr?.response?.status === 404
      ? PR_ALREADY_DELETED_MESSAGE
      : PR_DELETE_FAILED_MESSAGE;
  }
}
